import { ReactElement, useState } from 'react';
import { EmptyStateButton, Info, Tooltip, Typography } from '@weareopenr/component-library';
import { useItem } from 'src/hooks/useItem/useItem';
import CreateAttributeRuleModal from 'src/components/CreateAttributeRuleModal';
import AttributeRuleCard from './AttributeRuleCard';
import { ATTRIBUTE_RULES_TOOLTIP } from './constants';
import styles from './AttributeRulesTab.module.scss';

interface IAttributeRulesTabProps {
  itemId: string;
}

const AttributeRulesTab = ({ itemId }: IAttributeRulesTabProps): ReactElement => {
  const { data: item } = useItem(itemId);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const rules = item?.attribute_rules ?? [];

  const defaults = {
    consumerName: item?.consumerName ?? null,
    description: item?.description,
    plu: item?.plu,
    imageUrl: item?.image ?? null,
  };

  return (
    <div className={styles['container']}>
      <div className={styles['title']}>
        <Typography size="xlarge" weight="bold">
          Attribute Rules
        </Typography>
        <Tooltip text={ATTRIBUTE_RULES_TOOLTIP}>
          <Info />
        </Tooltip>
      </div>
      <EmptyStateButton label="+ Add attribute rule" onClick={() => setIsCreateModalOpen(true)} />
      {rules.map((rule) => (
        <AttributeRuleCard key={rule.attribute_rule_id} rule={rule} defaults={defaults} />
      ))}
      <CreateAttributeRuleModal
        open={isCreateModalOpen}
        closeModal={() => setIsCreateModalOpen(false)}
        itemId={itemId}
      />
    </div>
  );
};

export default AttributeRulesTab;
